import React from 'react';
import { SkillNode, EquippedSkill } from '../types/skillTree';

interface Props {
  equippedSkills: EquippedSkill[];
  getSkillIcon: (skill: SkillNode) => string;
  onDragOver: (e: React.DragEvent) => void;
  onDrop: (e: React.DragEvent, slot: number) => void;
  onUnequip: (slot: number) => void;
}

const HOTBAR_SLOTS = [0, 1, 2, 3, 4, 5, 6, 7];

const SkillHotbar: React.FC<Props> = ({ equippedSkills, getSkillIcon, onDragOver, onDrop, onUnequip }) => (
  <div className="skill-hotbar-container">
    <div className="hotbar-header">
      <div className="hotbar-title">⚔️ Active Skills Hotbar</div>
      <div className="hotbar-hint">Drag active skills here to use in battle</div>
    </div>
    <div className="skill-hotbar">
      {HOTBAR_SLOTS.map(slot => {
        const equippedSkill = equippedSkills.find(es => es.hotbarSlot === slot);
        return (
          <div
            key={slot}
            className={`hotbar-slot ${equippedSkill ? 'filled' : 'empty'}`}
            onDragOver={onDragOver}
            onDrop={e => onDrop(e, slot)}
            onClick={() => equippedSkill && onUnequip(slot)}
            title={equippedSkill ? `Click to remove ${equippedSkill.skill.name}` : `Slot ${slot + 1} - Empty`}
          >
            <div className="hotbar-slot-number">{slot + 1}</div>
            {equippedSkill ? (
              <div className="hotbar-skill">
                <div className="hotbar-skill-icon">{getSkillIcon(equippedSkill.skill)}</div>
                <div className="hotbar-skill-name">{equippedSkill.skill.name}</div>
                {equippedSkill.skill.apCost && (
                  <div className="hotbar-skill-cost">AP: {equippedSkill.skill.apCost}</div>
                )}
                {equippedSkill.skill.cooldown && (
                  <div className="hotbar-skill-cooldown">CD: {equippedSkill.skill.cooldown}</div>
                )}
              </div>
            ) : (
              <div className="hotbar-empty-icon">+</div>
            )}
          </div>
        );
      })}
    </div>
  </div>
);

export default SkillHotbar;
